/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Subnachtragsnummer1Inputs */



/**

* @param {_Field_Subnachtragsnummer1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_subnachtragsnummer1 = /** @type {((inputs?: _Field_Subnachtragsnummer1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Subnachtragsnummer1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Sub-Nachtragsnummer")
});
export { _field_subnachtragsnummer1 as "_field_subNachtragsnummer" }